import { Validator } from 'vee-validate';
import {isString, isArray, regexForFormat, assertString} from '@config/utils';
import GeoJSON from 'ol/format/GeoJSON';

const dictionary = {
	"pt":{
		mask: {
			datetime 		: '##/##/#### ##:##:##',
            date            : '##/##/####',
			time 			: '##:##:##',
			numeric           : {
                                decimal: '',
                                thousands: '.',
                                prefix: '',
                                suffix: '',
                                precision: 0,
                                masked: false
                            },
            money           : {
                                decimal: ',',
                                thousands: '.',
                                prefix: '',
                                suffix: '',
                                precision: 2,
                                masked: false
                            },
		},
		messages:{
			required 		        : 'Este campo é obrigatório',
			date_format 	        : 'Formato de data inválida',
			email 			        : 'O e-mail é inválido',
            confirmed               : 'As passwords não correspondem',
            min                     : (fieldName, params, data) => {
				const min = params[0];
				return `O campo ${fieldName} deve conter no mínimo ${min} caracteres.`;
			},
            max                     : (fieldName, params, data) => {
				const max = params[0];
				return `O campo ${fieldName} não pode conter mais de ${max} caracteres.`;
			},
		}
	}
};
// Merges all defined languages in the dictionary but does not set the current locale.
Validator.localize(dictionary);


export const daterangepickercheckRule = {
    getMessage(field, data) {
        return `Este campo é obrigatório.`;
    },
    validate: (value) => {
        var startDate = moment(value.startDate);
        var endDate = moment(value.endDate);
        return (startDate.isValid()) && (endDate.isValid());
    },
    message: 'The {_field_} field is required.'
};

export const dateAfterRule = {
    getMessage(field, [otherValue, inclusion, otherField], data) {
        return `O campo ${field} deve ser ${inclusion ? 'superior ou igual a' : 'superior'} ${otherField}.`;
    },
    validate: (value, [otherValue, inclusion]) => {
        if(value && otherValue) {
            let _date = moment(value);
            let _otherdate = moment(otherValue);
            return inclusion ? _date >= _otherdate : _date > _otherdate;
        }
        return true;
    },
};

export const maxElementsRule = {
    getMessage(field, maxCount, data) {
        return (data && data.message) || `Number of ${field} must be ${maxCount[0]} or less`;
    },
    validate(data, maxCount) {
        if (data.length <= maxCount[0]) {
            return true;
        }
        return false;
    },
};

export const emailsRule = {
    getMessage(field, data) {
        return (data && data.message) || `The ${field} is not valid`;
    },
    validate(data, [separator]) {
        separator = separator || ';';
        const pattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
        let valid = true;
        if(data){
            if(isString(data)){
                data = data.split(separator).map(item => item.trim());
            }
            if(isArray(data)) {
                data.forEach(item => {
                    if(item && !pattern.test(item)){
                        valid = false;
                        return;
                    }
                });
            }else{
                return false;
            }
        }
        return valid;
    },
};

export const phoneRule = {
    getMessage(field, data) {
        return (data && data.message) || `The ${field} is not valid`;
    },
    validate(data) {
        const pattern = /^([\+0]\d{3})?\d{9}$/;
        if(data) {
            if (data.length > 0 && pattern.test(data)) {
                return true;
            }else{
                return false;
            }
        }
        return true;
    },
};

export const phonesRule = {
    getMessage(field, data) {
        return (data && data.message) || `The ${field} is not valid`;
    },
    validate(data, [separator]) {
        const pattern = /^([\+0]\d{3})?\d{9}$/;
        let valid = true;
        if(data){
            if(isString(data)){
                let delimiters = (separator ? separator : [',', ';']).join('');
                let re = new RegExp(`[${delimiters}]+`, 'gi');
                let vals = data.split(re);
                data = vals.map(item => item.trim());
            }

            if(isArray(data)) {
                data.forEach(item => {
                    if(item && !pattern.test(item)){
                        valid = false;
                        return;
                    }
                });
            }else{
                return false;
            }
        }
        return valid;
    },
};

export const emojisRule = {
    getMessage(field, data) {
        return (data && data.message) || `The text can not contain emojis`;
    },
    validate(data) {
        const pattern = /(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC69\uDC6E\uDC70-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD26\uDD30-\uDD39\uDD3D\uDD3E\uDDD1-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])?|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDEEB\uDEEC\uDEF4-\uDEF8]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4C\uDD50-\uDD6B\uDD80-\uDD97\uDDC0\uDDD0-\uDDE6])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267B\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEF8]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4C\uDD50-\uDD6B\uDD80-\uDD97\uDDC0\uDDD0-\uDDE6])\uFE0F/g;
        if (!pattern.test(data)) {
            return true;
        }
        return false;
    },
};

export const minElementsRule = {
    getMessage(field, minCount, data) {
        return (data && data.message) || `Number of ${field} must be ${minCount[0]} or more`;
    },
    validate(data, minCount) {
        if (data.length >= minCount[0]) {
            return true;
        }
        return false;
    },
};

export const numElementsRule = {
    getMessage(field, minCount, data) {
        return (data && data.message) || `Number of ${field} must be ${minCount[0]}`;
    },
    validate(data, minCount) {
        if (data.length == minCount[0]) {
            return true;
        }
        return false;
    },
};

export const periodoRule = {
    getMessage(field, args) {
        if(args[0] == 'fim'){
            return 'Data final não pode ser menor que a inicial'
        }
        return 'Data inicial não pode ser maior que a final'
    },
    validate(value,args) {
        if(args[0] == 'inicio' && args[1] != null){
            var startDate = value.split("/");
            var dateStart = new Date(startDate[2], startDate[1], startDate[0]);

            var endDate = args[1].split("/");
            var dateEnd = new Date(endDate[2], endDate[1], endDate[0]);

            if(dateStart.getTime() > dateEnd.getTime()){
                return false;
            }else{
                return true;
            }
        }

        if(args[0] == 'fim' && args[1] != null){
            var endDate = value.split("/");
            var dateEnd = new Date(endDate[2], endDate[1], endDate[0]);

            var startDate = args[1].split("/");
            var dateStart = new Date(startDate[2], startDate[1], startDate[0]);

            if(dateEnd.getTime() < dateStart.getTime()){
                return false;
            }else{
                return true;
            }
        }
        return true;
    }
};

export const greaterThanRule = {
    validate: (value, [other]) => {
      return value && other ? Number(value) > Number(other) : true;
    },
    getMessage: (field, [target]) => `The ${field} must be greater than the ${target} field.`,
};

export const isContainedRule = {
    getMessage: field => 'The first feature must contain the second feature.',
    validate: (value, [testProp]) => {
        if(value && value.length==2){
            let firstGeom = value[0].getGeometry().clone();
            firstGeom.scale(1.001);
            let secondGeom = value[1].getGeometry().clone();
            switch(secondGeom.getType().toLowerCase()){
                case 'polygon':
                    secondGeom = secondGeom.getLinearRing(0);
                    break;
            }
            let coords = secondGeom.getCoordinates();
            let outside = coords.find( c => !firstGeom.intersectsCoordinate(c.map(a => Number(a.toFixed(4)))));
            return !outside;
        }
        return true;
    }
};

export const geometryFeatureRule = {
    getMessage: field => 'The input data is not a valid Geometry as GeoJSON format.',
    validate: (data) => {
        if(data){
            // validate JSON
            try {
                JSON.parse(data);
            } catch (e) {
                return false;
            }
            // validate GeoJSON
            if(data){
                try {
                    let geometry = (new GeoJSON()).readGeometry(data);
                    return !!geometry;
                } catch (e) {
                    return false;
                }
            }
        }
        return true;
    }
};
// Latitudes range from 0 to 90.
// Longitudes range from 0 to 180.
// Minutes & Seconds range from 0-60
const patternsLatLng = {
    lat: {
        //40° 26′ 46″ N 79° 58′ 56″ W
        isDMS: /^(([1-8]?[0-9])\D+([1-5]?[0-9]|60)\D+([0-5]?[0-9]|60)(\.[0-9]+)?|90\D+0\D+0)\D+[NSns]$/,
        // 40° 26.767′ N    79° 58.933′ W
        isDDM: /^(([1-8]?[0-9])\D+[1-6]?[0-9](\.\d{1,3})?|90(\D+0)?)\D+([NSns])$/,
        //  40.446° N         79.982° W
        isDD:  /^[\+-]?(([1-8]?[0-9])(\.\d{1,6})?|90)\D*[NSns]?$/
    },
    lng: {
        isDMS: /^((1[0-7][0-9]|[1-9]?[0-9])\D+([1-5]?[0-9]|60)\D+([0-5]?[0-9]|60)(\.[0-9]+)?|180\D+0\D+0)\D+[EWew]$/,
        isDDM: /^((1[0-7][0-9]|[1-9]?[0-9])\D+[1-6]?[0-9](\.\d{1,3})?|180(\D+0)?)\D+([EWew])$/,
        isDD:  /^[\+-]?((1[0-7][0-9]|[1-9]?[0-9])(\.\d{1,6})?|180)\D*[EWew]?$/
    }
};
const lat = /^\(?[+-]?(90(\.0+)?|[1-8]?\d(\.\d+)?)$/;
const lng = /^\s?[+-]?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)\)?$/;
// const latDMS = /^(([1-8]?\d)\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|90\D+0\D+0)\D+[NSns]?$/i;
// const latDMS = /^[\+-]?(([1-8]?\d)\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|90\D+0\D+0)\D+[NSns]?$/i;
// const lngDMS = /^\s*([1-7]?\d{1,2}\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|180\D+0\D+0)\D+[EWew]?$/i;
// const lngDMS = /^[\+-]?([1-7]?\d{1,2}\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|180\D+0\D+0)\D+[EWew]?$/i;
const defaultLatLongOptions = {
    checkDMS: false,
};
export const latRule = {
    validate: (str, options) => {
        str = isString(str) ? str : str.toString();
        options = {...defaultLatLongOptions, ...options};

        if (str.includes(',')) return false;
        if (options.checkDMS) {
            return patternsLatLng.lat.isDMS.test(str);
        }
        return lat.test(str);
    },
};
export const lngRule = {
    validate: (str, options) => {
        str = isString(str) ? str : str.toString();
        options = {...defaultLatLongOptions, ...options};

        if (str.includes(',')) return false;
        if (options.checkDMS) {
            return patternsLatLng.lng.isDMS.test(str);
        }
        return lng.test(str);
    },
};
export const latLngRule = {
    validate: (str, options) => {
        assertString(str);
        options = {...options, ...defaultLatLongOptions};

        if (!str.includes(',')) return false;
        const pair = str.split(',');
        if ((pair[0].startsWith('(') && !pair[1].endsWith(')'))
            || (pair[1].endsWith(')') && !pair[0].startsWith('('))) return false;

        if (options.checkDMS) {
            return latDMS.test(pair[0]) && lngDMS.test(pair[1]);
        }
        return lat.test(pair[0]) && lng.test(pair[1]);
    },
};

export const usagePeriodRule = {
    getMessage: field => `The ${field} field is required.`,
    validate: (data, [index]) => {
        let item = data.find(item => {
            if(!!item){
                if(Object.prototype.toString.call(item) === '[object Object]') {
                    return item.index == index;
                }else{
                    return true;
                }
            }
        });
        return {
            valid: !!item,
            data: {
                required: true,
            }
        };
    }
};

export const dateRule = {
    validate: (data, format = false) => {
        return Promise.resolve((() => {
            if (format && typeof format === 'string') {
                return regexForFormat(format).test(data)
            }
            return !isNaN(Date.parse(data))
        })())
    }
};

export const codeRule = {
    getMessage(field, data) {
        return (data && data.message) || `The ${field} is not valid`;
    },
    validate(data) {
        const pattern = /^([a-zA-Z0-9_-]+)$/;
        if(data) {
            if (data.length > 0 && pattern.test(data)) {
                return true;
            }else{
                return false;
            }
        }
        return true;
    },
};

const validateNIF_PT = (value) =>  {
    // Check if it is null
    if (value === null) {
        return false;
    }

    // Check if the input is exactly 9 characters long and contains only digits
    if (!/^\d{9}$/.test(value)) {
        return false;
    }

    // Ensure the input is a string
    if (typeof value !== 'string') {
        return false;
    }

    const validationSets = {
      one: ['1', '2', '3', '5', '6', '8'],
      two: ['45', '70', '71', '72', '74', '75', '77', '79', '90', '91', '98', '99']
    };

    // Check the starting digits
    if (!validationSets.one.includes(value.substr(0, 1)) && !validationSets.two.includes(value.substr(0, 2))) {
        return false;
    }

    // Calculate the check digit
    const calc = value[0] * 9 + value[1] * 8 + value[2] * 7 + value[3] * 6 + value[4] * 5 + value[5] * 4 + value[6] * 3 + value[7] * 2;
    const mod11 = (Number(calc) % 11);
    const checkDigit = mod11 < 2 ? 0 : 11 - mod11;

    // Verify the check digit
    return checkDigit === Number(value[8]);
};

export const nifRule = {
    getMessage(field, data) {
        return (data && data.message) || `The ${field} is not valid`;
    },
    validate(data, { countryCode = 'PT' } = {}) {
        if(data) {
            if(countryCode && countryCode.toUpperCase() == 'PT') {
                return validateNIF_PT(data);
            }else{
                const pattern = /^([0-9]+)$/;
                return pattern.test(data);
            }
        }
        return true;
    },
};


export const setCustomValidatorRules = (locale) => {
	let instance = new Validator();
	instance.localize(locale);

    // load in the custom form input validators
    instance.extend('daterangepickercheck', daterangepickercheckRule);
    instance.extend('emojis', emojisRule);
    instance.extend('maxElements', maxElementsRule);
    instance.extend('minElements', minElementsRule);
    instance.extend('numElements', numElementsRule);
    instance.extend('isContained', isContainedRule);
    instance.extend('geometryFeature', geometryFeatureRule);
    instance.extend('usagePeriod', usagePeriodRule);
    instance.extend('phone', phoneRule);
    instance.extend('phones', phonesRule);
    instance.extend('emails', emailsRule);
    instance.extend('date', dateRule);
    instance.extend('dateAfter', dateAfterRule, {hasTarget: true});
    instance.extend('greaterThan', greaterThanRule, {hasTarget: true});
    instance.extend('lat', latRule);
    instance.extend('lng', lngRule);
    instance.extend('latLng', latLngRule);
    instance.extend('code', codeRule);
    instance.extend('nif', nifRule);
}